export default __webpack_public_path__ + "tmp_src/components/TextCollapse/TextCollapse.css.liquid";